"use client";
import Image from "next/image";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import Link from "next/link";
import { StepProps } from "../../Steps.types";

export default function Steps_About_Layout1({ data }: StepProps) {

  const steps = Array.isArray(data?.Step) ? data.Step : [];

  return (
    <div className="px-6 py-8 md:px-12 lg:px-16 xl:px-24 bg-th-bg-col min-h-screen flex flex-col items-center justify-center">
      <div className="max-w-xl mx-auto mb-10 text-center">
        <h1 className="text-3xl xl:text-4xl font-bold text-[#1f1f1f]">
          {data?.title || "Title"}
        </h1>
        <p className="mt-4 text-lg text-[#797979]">
          {data?.description || ""}
        </p>
      </div>

      <div className="w-full max-w-4xl">
        {steps.length === 0 ? (
          <p className="text-center text-gray-500 py-8">
            No steps available.
          </p>
        ) : (
          <Swiper
            modules={[Pagination, Autoplay]}
            autoplay={{ delay: 6000 }}
            pagination={{ clickable: true }}
            slidesPerView={1}
            spaceBetween={30}
          >
            {steps.map((item, idx) => {
              const imageUrl = item?.iconImage?.data?.attributes?.url || "";
              const altText =
                item?.iconImage?.data?.attributes?.alternativeText ||
                "Step Image";

              return (
                <SwiperSlide key={idx}>
                  <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg flex flex-col md:flex-row items-center gap-6">
                    <div className="w-full md:w-1/2 flex flex-col justify-center space-y-4">
                      <h2 className="text-2xl md:text-3xl font-bold text-[#1f1f1f]">
                        {item?.title || "Untitled"}
                      </h2>
                      <p className="text-[#797979] text-base md:text-lg font-medium text-justify">
                        {item?.text || ""}
                      </p>
                      {item?.href && (
                        <Link
                          href={item.href}
                          className="inline-block px-4 py-2 text-sm font-semibold text-white bg-black rounded-full hover:bg-gray-800 transition"
                        >
                          {item?.hrefText || "Learn More"}
                        </Link>
                      )}
                    </div>

                    <div className="w-full md:w-1/2 flex justify-center items-center">
                      <div className="w-full max-w-xs md:max-w-sm">
                        {imageUrl ? (
                          <Image
                            src={imageUrl}
                            alt={altText}
                            width={400}
                            height={400}
                            className="w-full h-auto rounded-3xl object-contain shadow-md"
                          />
                        ) : (
                          <div className="w-full h-40 rounded-3xl bg-gray-100 flex items-center justify-center text-gray-400 text-sm">
                            No Image
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
      </div>
    </div>
  );
}
